/**
 * Vue i18n loader
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 👉 直接引入 JSON
import enUS from './lang/en-US.json'
import zhCN from './lang/zh-CN.json'
import zhTW from './lang/zh-TW.json'

import { axios } from '@/utils/request'

Vue.use(VueI18n)

export const defaultLang = 'zh-CN'

const messages = {
  'en-US': enUS,
  'zh-CN': zhCN,
  'zh-TW': zhTW
}

const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
})

export default i18n

const loadedLanguages = [defaultLang]

// 从缓存中加载语言
if (defaultLang !== localStorage.lang) {
  loadLanguageAsync(localStorage.lang)
}

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang = defaultLang) {
  return new Promise(resolve => {
    localStorage.lang = lang

    if (i18n.locale !== lang) {
      if (!loadedLanguages.includes(lang)) {
        // 👉 动态加载 JSON
        return import(
          /* webpackChunkName: "lang-[request]" */
          `./lang/${lang}.json`
          ).then(msg => {
          i18n.setLocaleMessage(lang, msg.default)
          loadedLanguages.push(lang)
          return resolve(setI18nLanguage(lang))
        })
      }
      return resolve(setI18nLanguage(lang))
    }

    return resolve(lang)
  })
}
